import { COVERABLE_CODE } from '../../../constants/coverable';
import { type ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { type CoverablePriceKey } from '../types';

const getEditCoverableKey = (coverableCode: ProductName_Top): CoverablePriceKey => {
    switch (coverableCode) {
        case COVERABLE_CODE.dog:
            return 'dog';
        case COVERABLE_CODE.cat:
            return 'cat';
        case COVERABLE_CODE.privateContent:
            return 'content';
        case COVERABLE_CODE.car:
            return 'car';
        case COVERABLE_CODE.travelHousehold:
        case COVERABLE_CODE.travelIndividual:
            return 'travel';
        case COVERABLE_CODE.accident:
            return 'adultAccident';
        default:
            throw new Error(`Unsupport for coverable with code: ${String(coverableCode)}`);
    }
};

export { getEditCoverableKey };
